import React from 'react'

const PersonalLoansForm = () => {
    return (
        <form className='text-dark'>
            {/* x---------------------------------x Personal Information x---------------------------------x */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-6">
                <h4 className="sm:col-span-2 text-lg font-semibold">Personal Information</h4>

                <div className="w-full">
                    <label htmlFor="fullName" className="block text-sm font-medium mb-2">Full Name</label>
                    <input type="text" id="fullName" placeholder="John Doe" required
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" />
                </div>

                <div className="w-full">
                    <label htmlFor="dob" className="block text-sm font-medium mb-2">Date of Birth</label>
                    <input type="date" id="dob" required
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" />
                </div>

                <div className="w-full">
                    <label htmlFor="email" className="block text-sm font-medium mb-2">Email Address</label>
                    <input type="email" id="email" placeholder="john.doe@example.com" required autoComplete='off'
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" />
                </div>

                <div className="w-full">
                    <label htmlFor="phoneNumber" className="block text-sm font-medium mb-2">Phone Number</label>
                    <input type="tel" id="phoneNumber" placeholder="+1 234 567 8900" required
                        autoComplete='off'
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" />
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="address" className="block text-sm font-medium mb-2">Residential Address</label>
                    <textarea id="address" rows="3" placeholder="123 Main St, Apt 4B, City, State, ZIP" required
                        autoComplete='off'
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"></textarea>
                </div>
            </div>

            {/* x---------------------------------x Loan Details x---------------------------------x */}
            <div className="grid grid-cols-1 gap-6 pb-6">
                <h4 className="text-lg font-semibold">Loan Details</h4>

                <div>
                    <label htmlFor="loanAmount" className="block text-sm font-medium mb-2">Loan Amount Requested</label>
                    <input type="number" id="loanAmount" placeholder="10000" required
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" />
                </div>

                <div>
                    <label htmlFor="loanPurpose" className="block text-sm font-medium mb-2">Purpose of Loan</label>
                    <textarea id="loanPurpose" rows="3" placeholder="Home renovation, debt consolidation, etc." required
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"></textarea>
                </div>

                <div>
                    <label htmlFor="loanTerm" className="block text-sm font-medium mb-2">Loan Term</label>
                    <select id="loanTerm" required defaultValue="DEFAULT"
                        className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0">
                        <option value="DEFAULT" disabled>Select term</option>
                        <option value="12">12 months</option>
                        <option value="24">24 months</option>
                        <option value="36">36 months</option>
                        <option value="48">48 months</option>
                        <option value="60">60 months</option>
                    </select>
                </div>
            </div>

            {/* x---------------------------------x Terms and Conditions / Submit Buttons x---------------------------------x */}
            <div className='flex flex-col'>
                {/* x---------------------------------x Terms and Conditions x---------------------------------x */}
                <div className="mb-4 flex items-center gap-2">
                    <input type="checkbox" id="terms" required
                        className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary" />
                    <label className="text-sm" htmlFor="terms">I agree to the terms and conditions.</label>
                </div>

                {/* x---------------------------------x Submit Button x---------------------------------x */}
                <div>
                    <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-4 w-full md:w-auto">
                        Submit Application
                    </button>
                </div>
            </div>
        </form>

    )
}

export default PersonalLoansForm